var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.link)?[_c('span',[_c('router-link',{attrs:{"to":{ name: 'account-edit-dns', params: { accountId: this.$route.params.accountId, domain: _vm.name }}}},[_vm._v(_vm._s(_vm.name))])],1)]:_vm._e(),(!_vm.link)?[_c('span',[_vm._v(_vm._s(_vm.name))])]:_vm._e(),_c('p',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.status))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }